
import SmsTracking from "../../../assets/duotone/SmsTracking.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SmsTrackingIcon({ className, dataTestid = "SmsTrackingIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SmsTracking data-testid={dataTestid} className={classes} {...rest} />
  );
}
